import React, { useContext, useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './LoginCard.css';
import { handleLogin, QRCodeContext } from '../context';

const LoginCard = () => {
  const { state, dispatch } = useContext(QRCodeContext) 
  const [loading, setLoading] = useState(false);
  const login = (datas) => {
    setLoading(true)
    handleLogin(datas).then(e => {
      dispatch({ type: 'SESSION', payload: e })
      setLoading(false)
      message.success('Connexion reussie')
    }).catch(e => {
      message.error(e.message)
      setLoading(false)
    })
  }
  return (
    <div className="login-background">
      <Card title="Login" className="login-card">
        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={login}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Username" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Log in
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginCard;
